import './App.css';
import React from "react"
import { BrowserRouter } from "react-router-dom";
import Navbar from '../component/NavBar';
import Content from '../component/Content';
import Footer from '../component/Footer';
import ScrollToTop from '../component/ScrollToTop'




const App = (props) => (
    <div className="App">
        <BrowserRouter>
            <ScrollToTop/>
            <Navbar/>
            <Content />
            <Footer/>
            
        </BrowserRouter> 
    </div>
);


export default App;

